import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'crop-7-5', 'Crop75', [["path",{"d":"M4 8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -8"}]]);